<template>
  <div>
    <div class="comp_wrap">
      <div class="comp_wrap_title">
        常见疾病详情及处理
      </div>

      <div class="comp_wrap_cont">
        <div class="cont_col" v-for="(item, i1) in classList" :key="i1">
          <div class="cont_col_l">
            <div class="cont_col_img">
              <img :src="item.classImg" alt="">
            </div>
            <div class="cont_col_cls">
              {{ item.className }}
            </div>
          </div>

          <div class="cont_col_r">
            <div class="cont_items">
              <template v-for="(child) in item.children">
                <p>[{{ child.waterTypeName }}]</p>
                <div>
                  <span v-for="sub in child.subBreedList" :key="sub.id" :class="{ 'active': sub.id === breedId }"
                    @click="changeItem(sub, item.className)">
                    {{ sub.breedName }}
                  </span>
                </div>
              </template>
            </div>
          </div>

          <div class="cont_col_btn" @click="startDiagnosis(item.className)">
            <div :class="{ 'disabled': className !== item.className }">
              简易诊断
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dia_pop" v-if="showPopup">
      <div class="pop_panel">
        <div class="pop_close" @click="showPopup = false">
          <i class="el-input__icon el-icon-close"></i>
        </div>
        <div class="pop_title">
          {{ breedName }}诊断
        </div>

        <div class="pop_tabbar">
          <div v-for="(item, index) in symptomList" :key="item.id" :class="{ 'active': index === symptomIndex }"
            @click="changeSymptom(index)">
            {{ item.positionName }}
          </div>
        </div>

        <div class="pop_cont">
          <div class="pop_cont_inr">
            <template v-if="symptomList.length > 0 && symptomList[symptomIndex].optionList">
              <div class="pop_cont_col" v-for="(option, inx) in symptomList[symptomIndex].optionList"
                :class="{ 'active': option.checked }" @click="selectOption(option)">
                <i></i>
                <span>
                  {{ option.diseaseDesc }}
                </span>
              </div>
            </template>
          </div>
        </div>

        <div class="pop_pages">
          <div class="disabled" v-if="symptomIndex === 0">
            上一项：无
          </div>
          <div v-if="symptomIndex > 0" @click="symptomIndex --">
            上一项：{{ symptomList[symptomIndex - 1].positionName }}
          </div>
          <div>
            {{ symptomIndex + 1 }}/{{ symptomList.length }}
          </div>
          <div class="disabled" v-if="symptomIndex === symptomList.length - 1">
            上一项：无
          </div>
          <div v-if="symptomIndex < symptomList.length - 1" @click="symptomIndex ++">
            下一项：{{ symptomList[symptomIndex + 1].positionName }}
          </div>
        </div>
        
        <div class="pop_btns">
          <div class="start" @click="doDiagnosis">
            开始诊断
          </div>

          <div class="reset" @click="resetSymptom">
            重置
          </div>
        </div>
      </div>
    </div>

    <div class="result_pop" v-if="showResult">
      <div class="pop_panel">
        <div class="pop_close" @click="showResult = false">
          <i class="el-input__icon el-icon-close"></i>
        </div>

        <div class="pop_title">
          诊断结果
        </div>

        <div class="pop_result_inner">
          <div class="pop_result_col" v-for="item in resultList" :key="item.diseaseId">
            <h5>{{ item.diseaseName }}</h5>
            <span>概率</span>
            <p>{{ item.percent }}%</p>
            <div class="view_btn" @click="viewDetail(item.diseaseId)">
              查看
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="result_pop" v-if="showDetail">
      <div class="pop_panel">
        <div class="pop_close" @click="showDetail = false">
          <i class="el-input__icon el-icon-close"></i>
        </div>

        <div class="pop_title">
          {{ detailInfo ? detailInfo.diseaseName : '' }}
        </div>

        <div class="pop_cont">
          <div v-html="detailInfo ? detailInfo.treatment : ''">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'simple-diagnosis',
  data() {
    return {
      classList: [],
      symptomList: [],
      resultList: [],
      showPopup: false,
      showResult: false,
      showDetail: false,
      breedId: '',
      breedName: '',
      className: '',
      detailInfo: null,
      symptomIndex: 0,
    }
  },
  computed: {},
  methods: {
    changeItem(obj, _className) {
      if (this.breedId === obj.id) return
      this.breedId = obj.id
      this.breedName = obj.breedName
      this.className = _className
    },
    startDiagnosis(_className) {
      if (this.className === _className && this.breedId) {
        this.$axios('/zhiyu-diagnosis/diagnosisCommon/optionList/' + this.breedId).then((r) => {
          if (r.code === '00000') {
            this.symptomList = r.data.filter(v => v.positionName)
            this.symptomIndex = 0
            this.showPopup = true
          }
        })
      }
    },
    changeSymptom(inx) {
      this.symptomIndex = inx
    },
    selectOption(obj) {
      obj.checked = !obj.checked
      this.$forceUpdate()
    },
    resetSymptom() {
      this.symptomIndex = 0
      this.symptomList.forEach(d => {
        d.optionList.forEach(d2 => {
          d2.checked = false
        })
      })
    },
    doDiagnosis() {
      const arr = []
      this.symptomList.forEach(d1 => {
        d1.optionList.forEach((d2) => {
          if (d2.checked) {
            arr.push(d2.id)
          }
        })
      })
      if (arr.length === 0) {
        this.$message.warning('请至少选择一种症状')
        return
      }
      this.resultList = []

      this.$axios({
        url: '/zhiyu-diagnosis/diagnosisCommon/genResult',
        method: 'post',
        data: arr
      }).then((r) => {
        if (r.code === '00000') {
          if (r.data.length > 0) {
            this.resultList = r.data
            this.showResult = true
          } else {
            this.$message.warning('未匹配到对应的诊断结果')
          }
        }
      })
    },
    viewDetail(id) {
      this.detailInfo = null
      this.$axios('/zhiyu-diagnosis/diagnosisCommon/resultInfo/' + id).then((r) => {
        if (r.code === '00000') {
          this.detailInfo = r.data
          this.showDetail = true
        }
      })
    }
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
    this.$axios('/zhiyu-diagnosis/diagnosisCommon/breedList').then(
      (r) => {
        if (r.code === '00000') {
          r.data.forEach(d => {
            const inx = this.classList.findIndex(v => v.className === d.breedName)
            if (inx > -1) {
              this.classList[inx].children.push(d)
            } else {
              this.classList.push({
                className: d.breedName,
                classImg: d.img,
                children: [d]
              })
            }
          });
        }
      }
    )
  },
  mounted() {
    // 模板编译/挂载之后
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
}
</script>
<style lang="less" scoped>

.comp_wrap {
  width: 100%;
  height: 850px;
  box-sizing: border-box;
  padding: 25px 28px;
  background: #f9f8f4;
  .comp_wrap_title {
    width: 100%;
    position: relative;
    font-size: 20px;
    padding-left: 13px;
    line-height: 1;
    &:after {
      content: '';
      position: absolute;
      width: 6px;
      height: 20px;
      background-size: 100% 100%;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: linear-gradient(0deg, #fe69fb 0%, #089ddd 50%, #6be0bd 100%);
    }
  }
  .comp_wrap_cont {
    width: 100%;
    margin-top: 30px;
    height: calc(100% - 55px);
    overflow-y: auto;
    /* 自定义滚动条整体样式 */
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: rgba(0, 0, 0, .05);
    }
    
    /* 自定义滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
      width: 6px;
      height: 6px;
     background-color: rgba(0, 0, 0, .1);
      border-radius: 6px;
    }
    .cont_col {
      width: 100%;
      height: 236px;
      margin-bottom: 10px;
      background: #fff;
      box-sizing: border-box;
      padding: 16px 0 16px 18px;
      display: flex;
      .cont_col_l {
        width: 267px;
        .cont_col_img {
          width: 100%;
          height: 152px;
          padding: 1px;
          position: relative;
          box-sizing: border-box;
          > img {
            width: 100%;
            height: 100%;
          }
          &:after {
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }
        }
        .cont_col_cls {
          width: 100%;
          height: 42px;
          margin-top: 6px;
          background: #f9f8f4;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .cont_col_r {
        width: 1px;
        flex: 1;
        height: 100%;
        background: #f9f8f4;
        box-sizing: border-box;
        padding: 15px 0;
        margin-left: 15px;
        .cont_items {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 0 15px;
          overflow-y: auto;
          /* 自定义滚动条整体样式 */
          &::-webkit-scrollbar {
            width: 6px;
            height: 6px;
            background-color: rgba(255, 255, 255, .1);
          }
          
          /* 自定义滚动条滑块样式 */
          &::-webkit-scrollbar-thumb {
            width: 6px;
            height: 6px;
            background-color: rgba(255, 255, 255, .3);
            border-radius: 6px;
          }
          > p {
            margin-top: 20px;
            font-size: 16px;
            line-height: 1;
            &:first-of-type {
              margin-top: 0;
            }
          }
          > div {
            display: flex;
            flex-wrap: wrap;
            margin-top: 10px;
            > span {
              font-size: 18px;
              line-height: 1;
              padding: 8px 10px;
              border-radius: 6px;
              margin-right: 10px;
              cursor: pointer;
              &:last-of-type {
                margin-right: 0;
              }
              &.active {
                background: #5442FF;
                color: #fff;
              }
            }
          }
        }
      }

      .cont_col_btn {
        width: 200px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        > div {
          width: 112px;
          height: 48px;
          border-radius: 6px;
          background: #5442FF;
          font-size: 18px;
          color: #fff;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          &.disabled {
            opacity: .6;
          }
        }
      }
    }
  }
}


.dia_pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 13;
  .pop_panel {
    width: 1140px;
    height: 700px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    box-sizing: border-box;
    padding: 30px 45px 30px 30px;
    .pop_close {
      position: absolute;
      right: 23px;
      top: 23px;
      width: 16px;
      cursor: pointer;
      z-index: 14;
      i {
        font-size: 20px;
      }
    }
    .pop_title {
      width: 100%;
      position: relative;
      font-size: 22px;
      padding-left: 13px;
      line-height: 1;
      &:after {
        content: '';
        position: absolute;
        width: 6px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: linear-gradient(0deg, #fe69fb 0%, #089ddd 50%, #6be0bd 100%);
      }
    }
    .pop_tabbar {
      width: calc(100% -5px);
      height: 65px;
      background: red;
      margin-left: 5px;
      margin-top: 30px;
      background: #F7F7FB;
      display: flex;
      overflow: hidden;
      > div {
        height: 65px;
        line-height: 65px;
        cursor: pointer;
        padding: 0 35px;
        font-size: 20px;
        &.active {
          background: #fff;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 4px;
            background: #5442FF;
          }
        }
      }
    }
    .pop_cont {
      margin: 20px auto 0;
      width: calc(100% - 20px);
      height: 230px;
      border-bottom: 1px solid #E1E1E1;
      box-sizing: border-box;
      padding: 15px 0;
      .pop_cont_inr {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        /* 自定义滚动条整体样式 */
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: rgba(255, 255, 255, .1);
        }
        
        /* 自定义滚动条滑块样式 */
        &::-webkit-scrollbar-thumb {
          width: 6px;
          height: 6px;
          background-color: rgba(255, 255, 255, .3);
          border-radius: 6px;
        }
        .pop_cont_col {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          font-size: 20px;
          line-height: 30px;
          color: #060d23;
          cursor: pointer;
          &:last-of-type {
            margin-bottom: 0;
          }
          i {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            border: 2px solid #b6b6b6;
            box-sizing: border-box;
            margin-right: 15px;
          }
          span {
            width: 1px;
            flex: 1;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          &.active {
            color: #1800FC;
            i {
              border: 7px solid #5442FF;
            }
          }
        }
      }
    }
    .pop_pages {
      width: calc(100% - 20px);
      display: flex;
      align-items: center;
      margin: 25px auto 0;
      > div {
        width: 45%;
        font-size: 20px;
        color: #1800FC;
        &:nth-of-type(2) {
          width: 10%;
          color: #060D23;
        }
        &:last-of-type {
          text-align: right;
        }
        &.disabled {
          color: #ABABAC;
        }
      }
    }
    .pop_btns {
      display: flex;
      justify-content: center;
      margin-top: 100px;
      position: relative;
      .start {
        width: 262px;
        height: 62px;
        border-radius: 6px;
        background: #5442FF;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 20px;
        cursor: pointer;
      }
      .reset {
        display: flex;
        align-items: center;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        right: 180px;
        font-size: 20px;
        color: #060D23;
        img {
          width: 34px;
          margin-right: 10px;
        }
      }
    }
  }
}


.result_pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 14;
  .pop_panel {
    width: 1140px;
    height: 700px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    box-sizing: border-box;
    padding: 30px;
    .pop_close {
      position: absolute;
      right: 23px;
      top: 23px;
      width: 16px;
      cursor: pointer;
      z-index: 15;
      i {
        font-size: 20px;
      }
    }
    .pop_title {
      width: 100%;
      position: relative;
      font-size: 22px;
      padding-left: 13px;
      line-height: 1;
      &:after {
        content: '';
        position: absolute;
        width: 6px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
         background: linear-gradient(0deg, #fe69fb 0%, #089ddd 50%, #6be0bd 100%);
      }
    }

    .pop_result_inner {
      width: 100%;
      height: calc(100% - 60px);
      box-sizing: border-box;
      margin-top: 30px;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      /* 自定义滚动条整体样式 */
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: rgba(0, 0, 0, .05);
      }
      
      /* 自定义滚动条滑块样式 */
      &::-webkit-scrollbar-thumb {
        width: 6px;
        height: 6px;
        background-color: rgba(0, 0, 0, .1);
        border-radius: 6px;
      }

      .pop_result_col {
        width: 486px;
        height: 281px;
        background: #f7f7fb;
        margin-right: 34px;
        box-sizing: border-box;
        padding-top: 65px;
        padding-left: 67px;
        position: relative;
        &:nth-child(2n) {
          margin-right: 0;
          margin-bottom: 34px;
        }
        > h5 {
          font-size: 22px;
          line-height: 1;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-weight: 500;
        }
        > span {
          font-size: 16px;
          color: #666666;
          line-height: 1;
          margin-top: 75px;
          display: block;
        }
        > p {
          font-size: 40px;
          line-height: 1;
          margin-top: 15px;
        }
        .view_btn {
          position: absolute;
          right: 115px;
          bottom: 50px;
          display: flex;
          align-items: center;
          font-size: 20px;
          line-height: 1;
          color: #1800FC;
          cursor: pointer;
          > img {
            width: 20px;
            margin-left: 3px;
          }
        }
      }
    }

    .pop_cont {
      width: 1006px;
      margin-left: 14px;
      margin-top: 30px;
      background: #F7F7FB;
      box-sizing: border-box;
      height: calc(100% - 60px);
      padding: 50px;
      > div {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        font-size: 20px;
        /* 自定义滚动条整体样式 */
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: rgba(0, 0, 0, .05);
        }
        
        /* 自定义滚动条滑块样式 */
        &::-webkit-scrollbar-thumb {
          width: 6px;
          height: 6px;
          background-color: rgba(0, 0, 0, .1);
          border-radius: 6px;
        }
        :deep(#app) {
          height: auto !important;
        }
      }
    }
  }
}
</style>
